export default __webpack_public_path__ + "static/media/ContentCut.92514d17.svg";